// mixin.js
import Vue from 'vue';
import Component from 'vue-class-component';

// You can declare a mixin as the same style as components.
@Component
export default class WeMixin extends Vue {
  public weGoBack() {
    window.history.length > 1 ? this.$router.back() : this.$router.replace('/');
  }

  public weGoHome() {
    this.$router.replace('/');
  }

  public fixIosBlur() {
    setTimeout(() => {
      if (this.isIos()) {
        const currentPosition =
          document.documentElement.scrollTop || document.body.scrollTop;
        window.scrollTo(0, currentPosition - 1);
        window.scrollTo(0, currentPosition);
      }
    }, 100);
  }

  protected isIos(): boolean {
    const u = navigator.userAgent;
    return u.indexOf('iPhone') > -1 || u.indexOf('Mac OS') > -1;
  }
}
